import React, { useState } from 'react';
import axios from 'axios';

const AddVideoForm = () => {
  const [formData, setFormData] = useState({
    title: '',
    source: '',
    length: '',
    description: '',
    url: '',
    category: '', // New field for category
  });

  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('https://wholeness-forward.onrender.com/api/video/videos', formData);
      setMessage('Video added successfully!');
      setFormData({
        title: '',
        source: '',
        length: '',
        description: '',
        url: '',
        category: '', // Reset category too
      });
    } catch (error) {
      setMessage('Failed to add video. Please try again.');
    }
  };

  return (
    <div className="add-video-form">
      <h1>Add a New Video</h1>
      {message && <p>{message}</p>}
      <form onSubmit={handleSubmit}>
        
        <div>
          <label htmlFor="title">Title:</label>
          <input
            type="text"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label htmlFor="source">Source:</label>
          <input
            type="text"
            id="source"
            name="source"
            value={formData.source}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label htmlFor="length">Length:</label>
          <input
            type="text"
            id="length"
            name="length"
            placeholder="e.g., 4:36"
            value={formData.length}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label htmlFor="description">Description:</label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label htmlFor="url">Video URL:</label>
          <input
            type="url"
            id="url"
            name="url"
            placeholder="e.g., https://www.youtube.com/embed/abc123"
            value={formData.url}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label htmlFor="category">Category:</label>
          <input
            type="text"
            id="category"
            name="category"
            value={formData.category}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit">Add Video</button>
      </form>
    </div>
  );
};

export default AddVideoForm;
